import { FunctionComponentElement, HTMLAttributes, ReactNode } from 'react';
import { BaseIconProps } from '../Graphics/Icons/BaseIcon';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type InfoCardProps = HTMLAttributes<HTMLDivElement> & {
  icon: FunctionComponentElement<BaseIconProps>;
  heading: string;
  children: ReactNode;
};

export const InfoCard = ({ icon, heading, children, className, ...props }: InfoCardProps) => (
  <div className={joinClassNames(styles.infoCard, className)} {...props}>
    <div>{icon}</div>
    <div>
      <p className={styles.heading}>
        <strong>{heading}</strong>
      </p>
      <div className={styles.description}>{children}</div>
    </div>
  </div>
);

InfoCard.displayName = 'InfoCard';
